export class BoardApprovalProcessesResultDto {
    processCode: string;
    processDisplayText: string;
    processHelpKey: string;
    approvalRequirement: string;
}
